import { render, staticRenderFns } from "./importAdmission.vue?vue&type=template&id=408e7fa2"
import script from "./importAdmission.vue?vue&type=script&lang=js"
export * from "./importAdmission.vue?vue&type=script&lang=js"
import style0 from "./importAdmission.vue?vue&type=style&index=0&id=408e7fa2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports